import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-3 mb-4 settings-card" }
const _hoisted_2 = { class: "card-body p-4 p-xl-40" }
const _hoisted_3 = { class: "d-flex flex-wrap align-items-start justify-content-between gap-3 mb-4" }
const _hoisted_4 = { class: "settings-chip" }
const _hoisted_5 = { class: "mb-2 text-title fw-semibold mt-3" }
const _hoisted_6 = { class: "text-optional mb-0 settings-subtitle" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_9 = { class: "poster-editor-grid" }
const _hoisted_10 = { class: "poster-editor-head" }
const _hoisted_11 = { class: "poster-number" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "row g-3" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "settings-label" }
const _hoisted_16 = ["onChange"]
const _hoisted_17 = ["value", "placeholder", "onInput"]
const _hoisted_18 = { class: "settings-help mb-0 mt-2" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { class: "settings-label" }
const _hoisted_21 = ["value", "placeholder", "onInput"]
const _hoisted_22 = { class: "poster-preview" }
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = {
  key: 1,
  class: "poster-preview-empty"
}
const _hoisted_25 = { class: "poster-preview-caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("system_settings_page.second_screen")), 1),
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("system_settings_page.customer_display_promotions")), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("system_settings_page.customer_display_description")), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn style-five px-4",
          disabled: _ctx.isSaving,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('submit')))
        }, [
          (_ctx.isSaving)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("system_settings_page.save_display_content")), 1)
        ], 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posters, (poster, index) => {
          return (_openBlock(), _createElementBlock("article", {
            key: `customer-display-poster-${index}`,
            class: "poster-editor-card"
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("system_settings_page.poster_number", { number: index + 1 })), 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light btn-sm",
                onClick: ($event: any) => (_ctx.resetPoster(index))
              }, _toDisplayString(_ctx.$t("system_settings_page.reset")), 9, _hoisted_12)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("system_settings_page.promotion_image")), 1),
                _createElementVNode("input", {
                  type: "file",
                  class: "form-control settings-input settings-file-input mb-2",
                  accept: "image/*",
                  onChange: ($event: any) => (_ctx.handlePosterFileChange(index, $event))
                }, null, 40, _hoisted_16),
                _createElementVNode("input", {
                  value: poster.image,
                  type: "text",
                  class: "form-control settings-input",
                  placeholder: _ctx.$t('system_settings_page.promotion_image_placeholder'),
                  onInput: ($event: any) => (_ctx.updatePoster(index, 'image', ($event.target as HTMLInputElement).value))
                }, null, 40, _hoisted_17),
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("system_settings_page.promotion_image_help")), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("system_settings_page.promotion_caption")), 1),
                _createElementVNode("input", {
                  value: poster.caption,
                  type: "text",
                  maxlength: "90",
                  class: "form-control settings-input",
                  placeholder: _ctx.$t('system_settings_page.promotion_caption_placeholder'),
                  onInput: ($event: any) => (_ctx.updatePoster(index, 'caption', ($event.target as HTMLInputElement).value))
                }, null, 40, _hoisted_21)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_ctx.posterImageUrl(poster))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.posterImageUrl(poster),
                    alt: _ctx.posterCaption(poster)
                  }, null, 8, _hoisted_23))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t("system_settings_page.promotion_image")), 1)),
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.posterCaption(poster) || _ctx.$t("system_settings_page.preview_caption")), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}